export const SET_TESTING_STUB = 'SET_TESTING_STUB';
export const REQUEST_FAILED = 'REQUEST_FAILED';
export const BODY_SCALE_CAPTURE_METRIC_INFO = 'body_scan_assessment_start';
export const BODY_SCALE_SCAN_START = 'body_scan_start';
export const BODY_SCALE_PROGRESS_UPDATE = 'BODY_SCALE_PROGRESS_UPDATE';
export const BODY_SCALE_ERROR = 'body_scan_failed';
export const REQUEST_SAVE_BODY_SCALE_SCAN = 'body_scan_save_request';
export const REQUEST_SAVE_BODY_SCALE_SCAN_SUCCESS = 'REQUEST_SAVE_BODY_SCALE_SCAN_SUCCESS';
export const DISCARD_BODY_SCALE_SCAN = 'body_scan_discard';
export const REQUEST_BODY_SCALE_SCAN_STATS = 'REQUEST_BODY_SCALE_SCAN_STATS';
export const REQUEST_BODY_SCALE_SCAN_STATS_SUCCESS = 'body_scan_success';
export const REQUEST_SAVE_BODY_ASSESSMENT = 'body_scan_assessment_save';
export const REQUEST_SAVE_BODY_ASSESSMENT_SUCCESS = 'REQUEST_SAVE_BODY_ASSESSMENT_SUCCESS';
export const SET_BODY_ASSESSMENT_ANSWER = 'SET_BODY_ASSESSMENT_ANSWER';
export const NEXT_BODY_ASSESSMENT_QUESTION = 'NEXT_BODY_ASSESSMENT_QUESTION';
export const PREVIOUS_BODY_ASSESSMENT_QUESTION = 'PREVIOUS_BODY_ASSESSMENT_QUESTION';
export const BODY_SCALE_ONBOARDING_START = 'BODY_SCALE_ONBOARDING_START';
export const SHOW_BODY_TYPE_OPTIONS = 'body_scan_show_bodytype_options';
export const SET_SCAN_PROGRESS = 'SET_SCAN_PROGRESS';
export const REQUEST_OVERRIDE_BODY_COMPOSITION_AND_CONDITIONING = 'body_scan_override_bodytype_request';
export const REQUEST_OVERRIDE_BODY_COMPOSITION_AND_CONDITIONING_SUCCESS = 'body_scan_override_bodytype_success';
export const SET_IS_SCAN_CONTINUING_FROM_WEIGHT_TARGET = 'SET_IS_SCAN_CONTINUING_FROM_WEIGHT_TARGET';
export const REMOVE_SCALE_REQUEST = 'REMOVE_SCALE_REQUEST';
export const REMOVE_SCALE_SUCCESS = 'REMOVE_SCALE_SUCCESS';
export const REMOVE_SCALE_FAILURE = 'REMOVE_SCALE_FAILURE';
